module.exports = __webpack_public_path__ + "static/media/siddharth-nandi-hills-trip-08.f6ee1eeb.png";